import { Link } from 'react-router-dom'

const Hero = () => {
    return (
        <section id="home" className="section hero" role="banner">
            <div className="section-inner">
                <h1 className="title title-h1" aria-label="Professional Web Design Centurion">Professional<br aria-hidden="true" />Web Design</h1>
                <h2 className="subtitle subtitle-h2">Web Design Agency — Centurion, Pretoria &amp; Gauteng</h2>
                <p className="description">
                    Professional web design agency based in Centurion, Gauteng — trusted by South African businesses since 2014.
                    We deliver custom WordPress websites, React applications, SEO, Google Ads &amp; digital marketing solutions that drive real growth. Mobile-first, POPIA-compliant and built to rank on Google from day one.
                </p>
                <div className="hero-buttons">
                    <Link to="/portfolio" className="btn btn-primary" aria-label="View Our Work - Portfolio">View Our Work</Link>
                    <a href="#contact" className="btn btn-secondary" aria-label="Get in Touch - Contact Form">Get in Touch</a>
                </div>
            </div>
        </section>
    )
}

export default Hero
